import React  from "react";
import Modal from 'react-bootstrap/Modal'
import { useState } from 'react';

function Privacy() {
    const [show, setShow] = useState(false);
    const fullscreen = true;

  
    return (
      <>
        <button className="colorePrivacy" type="button" aria-label="Apri la Privacy Policy" onClick={() => setShow(true)}>
        <i class="fa fa-shield fa-2x" aria-hidden="true"></i>
        </button>
  
   

        <Modal
          
          show={show}
          fullscreen={fullscreen}
          onHide={() => setShow(false)}
          dialogClassName="modal-90w fade-left"
          aria-labelledby="example-custom-modal-styling-title"
          animation={true}
        >
        
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Privacy Policy
            </Modal.Title>
          </Modal.Header>
          <Modal.Body >
            <p>
          

<b>Ultimo aggiornamento: 03/02/2024</b>

<p>Questo avviso sulla privacy per Da Giannino l'Angolo D'abruzzo - Zeus S.r.l. ("noi", "ci", o "nostro"), descrive come e perché potremmo raccogliere, conservare, utilizzare e/o condividere ("elaborare") le tue informazioni quando utilizzi i nostri servizi ("Servizi"). Leggendo questo avviso sulla privacy, potrai comprendere i tuoi diritti sulla privacy e le tue scelte. Se non sei d'accordo con le nostre politiche e pratiche, ti preghiamo di non utilizzare i nostri Servizi.</p>
<br/><br/>
<h4>RIEPILOGO DEI PUNTI CHIAVE</h4>

Questo riepilogo fornisce i punti chiave del nostro avviso sulla privacy, ma puoi scoprire ulteriori dettagli su ciascuno di questi argomenti cliccando sul link che segue ciascun punto chiave o utilizzando la nostra tabella dei contenuti di seguito per trovare la sezione che stai cercando.

<h5>Quali informazioni personali elaboriamo?</h5>
Quando visiti, utilizzi o navighi nei nostri Servizi, potremmo elaborare informazioni personali a seconda di come interagisci con noi e con i Servizi, delle scelte che fai e dei prodotti e delle funzioni che utilizzi.

Scopri di più sulle informazioni personali che ci fornisci.

<h5>Elaboriamo informazioni personali sensibili?</h5>
Non elaboriamo informazioni personali sensibili.

<h5>Riceviamo informazioni da terze parti?</h5>
Possiamo ricevere informazioni da database pubblici, partner di marketing, piattaforme di social media e altre fonti esterne.

Scopri di più sulle informazioni raccolte da altre fonti.

<h5>Come elaboriamo le tue informazioni?</h5>
Elaboriamo le tue informazioni per fornire, migliorare e amministrare i nostri Servizi, comunicare con te, per la sicurezza e la prevenzione delle frodi, e per ottemperare alla legge. Possiamo anche elaborare le tue informazioni per altri scopi con il tuo consenso.

Elaboriamo le tue informazioni solo quando abbiamo una valida ragione legale per farlo.

Scopri di più su come elaboriamo le tue informazioni.

<h5>In quali situazioni e con quali parti condividiamo informazioni personali?</h5>
Possiamo condividere informazioni in situazioni specifiche e con specifiche terze parti.

Scopri di più su quando e con chi condividiamo le tue informazioni personali.

<h5>Quali sono i tuoi diritti?</h5>
A seconda della tua posizione geografica, la legge sulla privacy applicabile può conferirti determinati diritti riguardo alle tue informazioni personali.

Scopri di più sui tuoi diritti sulla privacy.

<h5>Come eserciti i tuoi diritti?</h5>
Il modo più semplice per esercitare i tuoi diritti è inviare una richiesta di accesso dei dati personali, o contattandoci. Valuteremo e agiremo su qualsiasi richiesta in conformità alle leggi applicabili sulla protezione dei dati.

<h5>Vuoi saperne di più su cosa facciamo con le informazioni che raccogliamo?</h5>
Rivedi l'avviso sulla privacy completo.
<br/><br/><br/><br/>
<h4>TABELLA DEI CONTENUTI</h4>

<table>
      <thead>
        <tr>
         
        </tr>
      </thead>
      <tbody>
        <tr>
          
          <td>1.CHE INFORMAZIONI RACCOGLIAMO?</td>
        </tr>
        <tr>
          
          <td>2.COME ELABORIAMO LE TUE INFORMAZIONI?</td>
        </tr>
        <tr>
         
          <td>3.QUANDO E CON CHI CONDIVIDIAMO LE TUE INFORMAZIONI PERSONALI?</td>
        </tr>
        <tr>
         
          <td>4.UTILIZZIAMO COOKIE E ALTRI STRUMENTI DI TRACCIAMENTO?</td>
        </tr>
        <tr>
          
          <td>5.COME GESTIAMO I TUOI ACCESSI SOCIALI?</td>
        </tr>
        <tr>
          
          <td>6.LE TUE INFORMAZIONI SONO TRASFERITE A LIVELLO INTERNAZIONALE?</td>
        </tr>
        <tr>
         
          <td>7.QUANTO TEMPO CONSERVIAMO LE TUE INFORMAZIONI?</td>
        </tr>
        <tr>
         
          <td>8.RACCOGLIAMO INFORMAZIONI DA MINORI?</td>
        </tr>
        <tr>
          
          <td>9.QUALI SONO I TUOI DIRITTI ALLA PRIVACY?</td>
        </tr>
        <tr>
          
          <td>10.CONTROLLI PER LE FUNZIONI DO-NOT-TRACK?</td>        </tr>
        <tr>
          
          <td>11.AGGIORNIAMO QUESTO AVVISO?</td>
        </tr>
        <tr>
          
          <td>12.COME PUOI CONTATTARCI SU QUESTO AVVISO?</td>
        </tr>
        <tr>
         
          <td>13.COME PUOI RIVEDERE, AGGIORNARE O CANCELLARE I DATI CHE RACCOGLIAMO DA TE?</td>
        </tr>
      </tbody>
    </table>

<h5>1. CHE INFORMAZIONI RACCOGLIAMO?</h5>

Informazioni personali che ci fornisci
Raccogliamo informazioni

 personali quando interagisci con noi, come quando utilizzi i nostri Servizi, crei un account, compili un modulo online, interagisci con i nostri social media, o comunicaci tramite posta elettronica.

Informazioni che raccogliamo automaticamente
Raccogliamo automaticamente informazioni sul tuo dispositivo e sul tuo comportamento quando utilizzi i nostri Servizi, come il tuo indirizzo IP, il tipo di browser, il sistema operativo, i siti web da cui provieni e le pagine visitate.

<h5>2. COME ELABORIAMO LE TUE INFORMAZIONI?</h5>

Elaboriamo le tue informazioni per fornire, migliorare e amministrare i nostri Servizi, comunicare con te, per la sicurezza e la prevenzione delle frodi, e per ottemperare alla legge. Possiamo anche elaborare le tue informazioni per altri scopi con il tuo consenso.

<h5>3. QUANDO E CON CHI CONDIVIDIAMO LE TUE INFORMAZIONI PERSONALI?</h5>

Condividiamo informazioni in situazioni specifiche e con specifiche terze parti, come fornitori di servizi, autorità governative e altri.

<h5>4. UTILIZZIAMO COOKIE E ALTRI STRUMENTI DI TRACCIAMENTO?</h5>

Utilizziamo cookie e strumenti di tracciamento simili per raccogliere informazioni sulle tue attività online, come le tue preferenze e le pagine che visiti, per migliorare la tua esperienza utente e personalizzare la pubblicità.

<h5>5. COME GESTIAMO I TUOI ACCESSI SOCIALI?</h5>

Puoi scegliere di connettere i tuoi account dei social media ai nostri Servizi per semplificare il processo di accesso e per condividere contenuti.

<h5>6. LE TUE INFORMAZIONI SONO TRASFERITE A LIVELLO INTERNAZIONALE?</h5>

Le tue informazioni possono essere trasferite e conservate in un paese diverso da quello in cui risiedi. Adottiamo misure di sicurezza adeguate per proteggere le tue informazioni personali durante il trasferimento.

<h5>7. QUANTO TEMPO CONSERVIAMO LE TUE INFORMAZIONI?</h5>

Conserviamo le tue informazioni per il tempo necessario per adempiere agli scopi per cui sono state raccolte, a meno che non sia richiesto o consentito dalla legge una conservazione più lunga.

<h5>8. RACCOGLIAMO INFORMAZIONI DA MINORI?</h5>

I nostri Servizi non sono destinati ai minori di 18 anni e non raccogliamo consapevolmente informazioni personali da minori senza il consenso dei genitori o dei tutori legali.

<h5>9. QUALI SONO I TUOI DIRITTI ALLA PRIVACY?</h5>

A seconda della tua posizione geografica, la legge sulla privacy applicabile può conferirti determinati diritti riguardo alle tue informazioni personali, come il diritto di accedere, correggere, cancellare, limitare o opporsi al trattamento delle tue informazioni.

<h5>10. CONTROLLI PER LE FUNZIONI DO-NOT-TRACK</h5>

Il tuo browser web potrebbe offrire funzionalità Do Not Track ("DNT"). Attualmente, non rispondiamo ai segnali DNT del browser.

<h5>11. AGGIORNIAMO QUESTO AVVISO?</h5>

Aggiorniamo periodicamente questo avviso per riflettere le modifiche nei nostri Servizi, nelle nostre pratiche di trattamento delle informazioni e nelle leggi applicabili sulla privacy.

<h5>12. COME PUOI CONTATTARCI SU QUESTO AVVISO?</h5>

Se hai domande o dubbi su questo avviso sulla privacy, prego di contattarci ai nostri riferimenti.

<h5>13. COME PUOI RIVEDERE, AGGIORNARE O CANCELLARE I DATI CHE RACCOGLIAMO DA TE?</h5>

Puoi richiedere di accedere, aggiornare o cancellare le tue informazioni personali inviando una richiesta tramite i contatti forniti di seguito.
<br/><br/>
<h4>CONTATTACI</h4>

Se hai domande o dubbi su questo avviso sulla privacy, ti preghiamo di contattarci all'indirizzo email: angolodabruzzo@outlook.it
            </p>
          </Modal.Body>
        </Modal>
  
      </>
    );
  }
  
 export default Privacy;

